/**
 * "What's new" on /download (Paul, Oct 28 2026): release notes moved from the old /downloads page.
 * Merged into every catalog by translations.js.
 */
const downloadWhatsNewI18n = {
  en: {
    'dl.whatsNew.title': "What's new",
    'dl.whatsNew.subtitle': 'Recent changes to the Maestro desktop app. Maestro updates itself, so you rarely need to download it again.',
    'dl.whatsNew.latest': 'Latest',
    'dl.whatsNew.major': 'Major release',
    'dl.whatsNew.earlier': 'Earlier releases',
    'dl.whatsNew.noNotes': 'No release notes for this version.',
    'dl.whatsNew.loading': 'Loading release notes…',
    'dl.whatsNew.error': "Release notes aren't available right now. Please try again later.",
    'dl.whatsNew.versionTitle': 'Which version do I have?',
    'dl.whatsNew.versionBody': 'In Maestro, click Settings in the left sidebar and scroll to the bottom. Your version is shown there, along with Check for Updates.',
    'dl.whatsNew.thisVersion': 'Download this version:',
    'dl.whatsNew.macArm': 'Mac (Apple chip)',
    'dl.whatsNew.macIntel': 'Mac (Intel)',
    'dl.whatsNew.windows': 'Windows',
  },
  es: {
    'dl.whatsNew.title': 'Novedades',
    'dl.whatsNew.subtitle': 'Cambios recientes en la app de escritorio Maestro. Maestro se actualiza solo, así que rara vez tendrás que volver a descargarlo.',
    'dl.whatsNew.latest': 'Más reciente',
    'dl.whatsNew.major': 'Versión principal',
    'dl.whatsNew.earlier': 'Versiones anteriores',
    'dl.whatsNew.noNotes': 'No hay notas para esta versión.',
    'dl.whatsNew.loading': 'Cargando notas de la versión…',
    'dl.whatsNew.error': 'Las notas de la versión no están disponibles ahora. Inténtalo de nuevo más tarde.',
    'dl.whatsNew.versionTitle': '¿Qué versión tengo?',
    'dl.whatsNew.versionBody': 'En Maestro, haz clic en Ajustes en la barra lateral izquierda y desplázate hasta abajo. Allí verás tu versión, junto a Buscar actualizaciones.',
    'dl.whatsNew.thisVersion': 'Descargar esta versión:',
    'dl.whatsNew.macArm': 'Mac (chip de Apple)',
    'dl.whatsNew.macIntel': 'Mac (Intel)',
    'dl.whatsNew.windows': 'Windows',
  },
  fr: {
    'dl.whatsNew.title': 'Nouveautés',
    'dl.whatsNew.subtitle': "Les derniers changements de l'app de bureau Maestro. Maestro se met à jour tout seul, vous n'aurez donc que rarement à le retélécharger.",
    'dl.whatsNew.latest': 'Dernière',
    'dl.whatsNew.major': 'Version majeure',
    'dl.whatsNew.earlier': 'Versions précédentes',
    'dl.whatsNew.noNotes': 'Aucune note pour cette version.',
    'dl.whatsNew.loading': 'Chargement des notes de version…',
    'dl.whatsNew.error': 'Les notes de version ne sont pas disponibles pour le moment. Réessayez plus tard.',
    'dl.whatsNew.versionTitle': 'Quelle version ai-je ?',
    'dl.whatsNew.versionBody': 'Dans Maestro, cliquez sur Réglages dans la barre latérale gauche et faites défiler jusqu’en bas. Votre version y figure, avec Rechercher des mises à jour.',
    'dl.whatsNew.thisVersion': 'Télécharger cette version :',
    'dl.whatsNew.macArm': 'Mac (puce Apple)',
    'dl.whatsNew.macIntel': 'Mac (Intel)',
    'dl.whatsNew.windows': 'Windows',
  },
  de: {
    'dl.whatsNew.title': 'Neuigkeiten',
    'dl.whatsNew.subtitle': 'Aktuelle Änderungen an der Maestro Desktop-App. Maestro aktualisiert sich selbst, Sie müssen es also nur selten neu herunterladen.',
    'dl.whatsNew.latest': 'Neueste',
    'dl.whatsNew.major': 'Großes Update',
    'dl.whatsNew.earlier': 'Frühere Versionen',
    'dl.whatsNew.noNotes': 'Keine Hinweise zu dieser Version.',
    'dl.whatsNew.loading': 'Versionshinweise werden geladen…',
    'dl.whatsNew.error': 'Die Versionshinweise sind gerade nicht verfügbar. Bitte versuchen Sie es später erneut.',
    'dl.whatsNew.versionTitle': 'Welche Version habe ich?',
    'dl.whatsNew.versionBody': 'Klicken Sie in Maestro links in der Seitenleiste auf Einstellungen und scrollen Sie ganz nach unten. Dort steht Ihre Version, zusammen mit Nach Updates suchen.',
    'dl.whatsNew.thisVersion': 'Diese Version herunterladen:',
    'dl.whatsNew.macArm': 'Mac (Apple-Chip)',
    'dl.whatsNew.macIntel': 'Mac (Intel)',
    'dl.whatsNew.windows': 'Windows',
  },
  it: {
    'dl.whatsNew.title': 'Novità',
    'dl.whatsNew.subtitle': "Le ultime modifiche all'app desktop Maestro. Maestro si aggiorna da solo, quindi raramente dovrai scaricarlo di nuovo.",
    'dl.whatsNew.latest': 'Più recente',
    'dl.whatsNew.major': 'Versione principale',
    'dl.whatsNew.earlier': 'Versioni precedenti',
    'dl.whatsNew.noNotes': 'Nessuna nota per questa versione.',
    'dl.whatsNew.loading': 'Caricamento note di rilascio…',
    'dl.whatsNew.error': 'Le note di rilascio non sono disponibili al momento. Riprova più tardi.',
    'dl.whatsNew.versionTitle': 'Quale versione ho?',
    'dl.whatsNew.versionBody': 'In Maestro, fai clic su Impostazioni nella barra laterale sinistra e scorri fino in fondo. Lì trovi la tua versione, insieme a Controlla aggiornamenti.',
    'dl.whatsNew.thisVersion': 'Scarica questa versione:',
    'dl.whatsNew.macArm': 'Mac (chip Apple)',
    'dl.whatsNew.macIntel': 'Mac (Intel)',
    'dl.whatsNew.windows': 'Windows',
  },
  pt: {
    'dl.whatsNew.title': 'Novidades',
    'dl.whatsNew.subtitle': 'Mudanças recentes no app Maestro para computador. O Maestro se atualiza sozinho, então raramente você precisará baixá-lo de novo.',
    'dl.whatsNew.latest': 'Mais recente',
    'dl.whatsNew.major': 'Versão principal',
    'dl.whatsNew.earlier': 'Versões anteriores',
    'dl.whatsNew.noNotes': 'Sem notas para esta versão.',
    'dl.whatsNew.loading': 'Carregando notas da versão…',
    'dl.whatsNew.error': 'As notas da versão não estão disponíveis agora. Tente novamente mais tarde.',
    'dl.whatsNew.versionTitle': 'Qual versão eu tenho?',
    'dl.whatsNew.versionBody': 'No Maestro, clique em Ajustes na barra lateral esquerda e role até o fim. Sua versão aparece ali, junto com Verificar atualizações.',
    'dl.whatsNew.thisVersion': 'Baixar esta versão:',
    'dl.whatsNew.macArm': 'Mac (chip Apple)',
    'dl.whatsNew.macIntel': 'Mac (Intel)',
    'dl.whatsNew.windows': 'Windows',
  },
  ja: {
    'dl.whatsNew.title': '新機能',
    'dl.whatsNew.subtitle': 'Maestro デスクトップアプリの最近の変更点です。Maestro は自動でアップデートされるため、再ダウンロードが必要になることはほとんどありません。',
    'dl.whatsNew.latest': '最新',
    'dl.whatsNew.major': 'メジャーリリース',
    'dl.whatsNew.earlier': '以前のリリース',
    'dl.whatsNew.noNotes': 'このバージョンのリリースノートはありません。',
    'dl.whatsNew.loading': 'リリースノートを読み込み中…',
    'dl.whatsNew.error': '現在リリースノートを表示できません。しばらくしてからもう一度お試しください。',
    'dl.whatsNew.versionTitle': '自分のバージョンを確認するには？',
    'dl.whatsNew.versionBody': 'Maestro の左サイドバーで「設定」をクリックし、一番下までスクロールしてください。「アップデートを確認」と一緒にバージョンが表示されます。',
    'dl.whatsNew.thisVersion': 'このバージョンをダウンロード：',
    'dl.whatsNew.macArm': 'Mac（Apple チップ）',
    'dl.whatsNew.macIntel': 'Mac（Intel）',
    'dl.whatsNew.windows': 'Windows',
  },
  ko: {
    'dl.whatsNew.title': '새로운 기능',
    'dl.whatsNew.subtitle': 'Maestro 데스크톱 앱의 최근 변경 사항입니다. Maestro는 자동으로 업데이트되므로 다시 다운로드할 일은 거의 없습니다.',
    'dl.whatsNew.latest': '최신',
    'dl.whatsNew.major': '주요 릴리스',
    'dl.whatsNew.earlier': '이전 릴리스',
    'dl.whatsNew.noNotes': '이 버전의 릴리스 노트가 없습니다.',
    'dl.whatsNew.loading': '릴리스 노트를 불러오는 중…',
    'dl.whatsNew.error': '지금은 릴리스 노트를 볼 수 없습니다. 잠시 후 다시 시도해 주세요.',
    'dl.whatsNew.versionTitle': '내 버전은 어떻게 확인하나요?',
    'dl.whatsNew.versionBody': 'Maestro 왼쪽 사이드바에서 설정을 클릭하고 맨 아래로 스크롤하세요. 업데이트 확인과 함께 버전이 표시됩니다.',
    'dl.whatsNew.thisVersion': '이 버전 다운로드:',
    'dl.whatsNew.macArm': 'Mac (Apple 칩)',
    'dl.whatsNew.macIntel': 'Mac (Intel)',
    'dl.whatsNew.windows': 'Windows',
  },
  zh: {
    'dl.whatsNew.title': '新功能',
    'dl.whatsNew.subtitle': 'Maestro 桌面应用的最新变化。Maestro 会自动更新，因此很少需要重新下载。',
    'dl.whatsNew.latest': '最新',
    'dl.whatsNew.major': '重要版本',
    'dl.whatsNew.earlier': '早期版本',
    'dl.whatsNew.noNotes': '此版本没有更新说明。',
    'dl.whatsNew.loading': '正在加载更新说明…',
    'dl.whatsNew.error': '暂时无法显示更新说明，请稍后再试。',
    'dl.whatsNew.versionTitle': '我用的是哪个版本？',
    'dl.whatsNew.versionBody': '在 Maestro 中，点击左侧边栏的“设置”，然后滚动到底部。你的版本号会和“检查更新”一起显示在那里。',
    'dl.whatsNew.thisVersion': '下载此版本：',
    'dl.whatsNew.macArm': 'Mac（Apple 芯片）',
    'dl.whatsNew.macIntel': 'Mac（Intel）',
    'dl.whatsNew.windows': 'Windows',
  },
  nl: {
    'dl.whatsNew.title': 'Wat is er nieuw',
    'dl.whatsNew.subtitle': 'Recente wijzigingen in de Maestro desktop-app. Maestro werkt zichzelf bij, dus je hoeft hem zelden opnieuw te downloaden.',
    'dl.whatsNew.latest': 'Nieuwste',
    'dl.whatsNew.major': 'Grote release',
    'dl.whatsNew.earlier': 'Eerdere releases',
    'dl.whatsNew.noNotes': 'Geen releasenotes voor deze versie.',
    'dl.whatsNew.loading': 'Releasenotes laden…',
    'dl.whatsNew.error': 'De releasenotes zijn nu niet beschikbaar. Probeer het later opnieuw.',
    'dl.whatsNew.versionTitle': 'Welke versie heb ik?',
    'dl.whatsNew.versionBody': 'Klik in Maestro op Instellingen in de linkerzijbalk en scrol helemaal naar beneden. Daar staat je versie, samen met Zoeken naar updates.',
    'dl.whatsNew.thisVersion': 'Deze versie downloaden:',
    'dl.whatsNew.macArm': 'Mac (Apple-chip)',
    'dl.whatsNew.macIntel': 'Mac (Intel)',
    'dl.whatsNew.windows': 'Windows',
  },
  sv: {
    'dl.whatsNew.title': 'Nyheter',
    'dl.whatsNew.subtitle': 'Senaste ändringarna i Maestros skrivbordsapp. Maestro uppdaterar sig själv, så du behöver sällan ladda ner den igen.',
    'dl.whatsNew.latest': 'Senaste',
    'dl.whatsNew.major': 'Större version',
    'dl.whatsNew.earlier': 'Tidigare versioner',
    'dl.whatsNew.noNotes': 'Inga versionsanteckningar för den här versionen.',
    'dl.whatsNew.loading': 'Läser in versionsanteckningar…',
    'dl.whatsNew.error': 'Versionsanteckningarna är inte tillgängliga just nu. Försök igen senare.',
    'dl.whatsNew.versionTitle': 'Vilken version har jag?',
    'dl.whatsNew.versionBody': 'Klicka på Inställningar i vänstra sidofältet i Maestro och scrolla längst ner. Där står din version, tillsammans med Sök efter uppdateringar.',
    'dl.whatsNew.thisVersion': 'Ladda ner den här versionen:',
    'dl.whatsNew.macArm': 'Mac (Apple-chip)',
    'dl.whatsNew.macIntel': 'Mac (Intel)',
    'dl.whatsNew.windows': 'Windows',
  },
};

export default downloadWhatsNewI18n;
